export default __webpack_public_path__ + "static/media/right9.02d187cb.png";